import Plyr from '../../../assets/custom_components/plyr/plyr'

/* @ngInject */
function AuditSocialMediaPostController ($rootScope, $window, $scope, $q, $attrs, $translate, $timeout, UdsModalService, SocialMediaService, ToastService, Utils, UserService) {
  const getSocialMediaNonConformityController = () => $q.when(import('../../dialogs/social-media/non-conformity/non-conformity.controller'))

  $scope.flags = {
    wasLiked: $scope.post.wasLiked,
    loading: false
  }

  const api = {
    getSocialMediaNonConformityController,
    _getDateTimeFormat
  }

  this.getApi = () => api

  activate()

  function activate () {}

  $scope.onLike = async (post) => {
    if ($scope.flags.loading) {
      return
    }

    $scope.flags.loading = true
    $scope.flags.wasLiked = !$scope.flags.wasLiked

    try {
      await SocialMediaService.likePost(post.id)
    } catch (err) {
      console.log({ err })
      ToastService.defaultErrorToast()
    } finally {
      $timeout(() => {
        $scope.flags.loading = false
      })
    }
  }

  $scope.onReport = (post) => {
    api.getSocialMediaNonConformityController().then(({ SocialMediaNonConformityController }) => {
      const socialMediaNonConformityDialog = UdsModalService.createModal({
        controller: SocialMediaNonConformityController,
        modalName: 'socialMediaNonConformityDialog',
        data: {
          reportType: 'post',
          ...post
        }
      })
      socialMediaNonConformityDialog.open()
    })
  }

  $scope.initializePlyrVideo = (post) => {
    const controls = [
      'play',
      'mute',
      'progress',
      'duration'
    ]

    const playerElement = $attrs.$$element.find('.preview__video')[0]
    const player = new Plyr(playerElement, { controls })

    player.source = {
      type: 'video',
      sources: [
        {
          src: post.assetUrl,
          type: 'video/mp4'
        }
      ]
    }
  }

  $scope.formatPublishDate = (publishedDate) => {
    const datePart = api._getDateTimeFormat(publishedDate, {
      day: '2-digit',
      month: '2-digit'
    })

    const timePart = api._getDateTimeFormat(publishedDate, {
      hour: '2-digit',
      minute: '2-digit'
    })

    return `${datePart} - ${timePart}`
  }

  $scope.getPostType = (type) => {
    return type.toLowerCase()
  }

  $scope.openLink = (link) => {
    $window.open(link, '_blank', 'noopener noreferrer')
  }

  function _getDateTimeFormat (date, options) {
    const locale = $rootScope.oUser.locale
    return new Intl.DateTimeFormat(locale, options).format(new Date(date))
  }

  $scope.getAvatarUrl = (account) => {
    return UserService.getUserProfileImage(account.user.id)
  }
}

export { AuditSocialMediaPostController }
